import React, {Component} from "react";
import _ from "lodash";
import {renderInput, renderSelectByList} from "../../services/renderService";

class Table1Body extends Component {

    handleChange = ({currentTarget: input}) => {
        // const errors = {...this.state.errors};
        // const errorMessage = this.validateProperty(input);
        // if (errorMessage) errors[input.name] = errorMessage;
        // else delete errors[input.name];
        //
        // const data = this.getNewData(input.name, input.value);
        //
        // this.setState({data, errors});
        // console.log("input=", input.name, input.value)
        const nameAndDbId = input.name.split("_");
        this.props.handleChange(nameAndDbId[1], nameAndDbId[0], input.value);
    };


    renderCell = (item, column) => {
        // console.log("renderCell(): item=", item, ", column=", column)

        const {itemsMap, itemList} = this.props;


        if (column.content) {
            return column.content(item);
        } else if (column.path === "vehicleType") {
            // return _.get(item, column.path);
            return renderSelectByList(
                {
                    type: "text",
                    name: column.path + "_" + item.dbId,
                    table: true,
                    itemsMap: itemsMap,
                    itemList: itemList,
                    nullable: true
                    // handleItemSelect: this.onChangeVendorContactPerson,
                },
                _.get(item, column.path),
                {},
                this.handleChange)
        } else {
            // return _.get(item, column.path);
            return renderInput(
                {
                    type: "text",
                    name: column.path + "_" + item.dbId,
                    table: true
                },
                _.get(item, column.path),
                {},
                this.handleChange)
        }
    };

    createKey = (item, column) => {
        return item.dbId + (column.path || column.key);
    };

    render = () => {
        const {data, columns, baseInformation} = this.props;
        console.log("Table1Body.render(): baseInformation=", baseInformation)
        console.log("Table1Body.render(): columns=", columns)
        return (
            <tbody>
            {data.map(item => (
                <tr key={item.dbId}>
                    {columns.map(column => (
                        <td key={this.createKey(item, column)}>
                            {this.renderCell(item, column)}
                        </td>
                    ))}
                    {columns.map(column => (
                        <td key={this.createKey(item, column)}>
                            {this.renderCell(item, column)}
                        </td>
                    ))}
                </tr>
            ))}
            </tbody>
        );
    }
}

export default Table1Body;
